module.exports = __webpack_public_path__ + "static/media/6.66053945.svg";